import { createSelector } from 'reselect';

const desktopSelector = createSelector(state => state.desktop, desktop => desktop)

export {desktopSelector}
